import axios from 'axios'

export default () => {
    return axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        withCredentials: false,
        crossDomain: true,
        headers: {
            "content-type": "application/x-www-form-urlencoded",
            "Accept": "application/json"
        }
    })
}